var debounce = {};
export {
  debounce as __exports
};
//# sourceMappingURL=debounce2.js.map
